export default {
    AuthState:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },
    traversingOutState:{
        data:{},
        error:null,
        loading:false
    },traversingInState:{
        data:{},
        error:null,
        loading:false
    }
}